
























import { Vue, Component } from 'vue-property-decorator';
import LoginForm from '@/views/Login/components/LoginForm';
import { MessageSpecialSituation } from '../../common/components';
import { ToastMessage } from '@/plugins/toast/models/message';
import lang from '../../common/lang/de';

export default Vue.extend({
  name: 'Index',
  components: {
    LoginForm,
    MessageSpecialSituation
  },
  data() {
    return {
      userId: '' as string,
      pageTitle: '' as string,
      subTitle: '' as string,
      isAutenticated: true as boolean,
      specialMessage: 'This is a message for special situation' as string
    };
  },
  created() {
    this.pageTitle = lang.login.title;
    this.subTitle = lang.login.subTitle;
  },
  mounted() {
    this.checkAutorization();
  },
  methods: {
    checkAutorization() {
      const message = {} as ToastMessage;
      if (sessionStorage.getItem('auth') !== null) {
        this.isAutenticated = false;
        sessionStorage.removeItem('auth');

        message.header = lang.global.error.NotAuthorized.header;
        message.message = lang.global.error.NotAuthorized.message;
        this.$toast.error(message);
      } else if (sessionStorage.getItem('exp') !== null) {
        this.isAutenticated = false;
        sessionStorage.removeItem('exp');

        message.header = lang.global.error.notLogged.header;
        message.message = lang.global.error.notLogged.message;
        this.$toast.error(message);
      }
    },
    loginSuccess(debtorNumber: number) {
      this.$router.push({
        name: 'Welcome',
        params: {
          id: debtorNumber.toString(),
        },
      });
    },
    loginSuccessCallCenter() {
      this.$router.push({
        name: 'CallCenterIndex',
      });
    },
    showError(message: string) {
      this.$toast.error(message);
    },
  },
});
